// extracted by mini-css-extract-plugin
module.exports = {"capitalize":"Bs-k64pQ","lowercase":"_3NdTfWy0"};